<template>
  <div style="margin-top: 7rem; min-height: 80vh">
    <div class="">
      <div class="d-flex justify-content-center">
        <div class="nav nav-pills" id="v-pills-tab" role="tablist">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            class="nav-link"
            :id="`v-pills-${tab.id}-tab`"
            data-toggle="pill"
            :data-target="`#v-pills-${tab.id}`"
            type="button"
            role="tab"
            :aria-controls="`v-pills-${tab.id}`"
            :aria-selected="activeTabIndex === index"
            :class="{ active: activeTabIndex === index }"
            @click="onChange(index)"
          >
            {{ tab.name }}
          </button>
        </div>
      </div>
      <div class="p-4 ">
        <div class="tab-content" id="v-pills-tabContent">
          <div
            v-if="activeTabIndex === 0"
            class="tab-pane show active"
            id="v-pills-corporate"
            role="tabpanel"
            aria-labelledby="v-pills-corporate-tab"
          >
          <div class="nav nav-tabs" id="v-pills-tab" role="tablist">
          <button
            v-for="(tab, index) in periods"
            :key="index"
            class="nav-link"
            :id="`v-pills-${tab.id}-tab`"
            data-toggle="pill"
            :data-target="`#v-pills-${tab.id}`"
            type="button"
            role="tab"
            :aria-controls="`v-pills-${tab.id}`"
            :aria-selected="activeTabIndexForPeriod === index"
            :class="{ active: activeTabIndexForPeriod === index }"
            @click="onPeriodChange(tab.id)"
          >
            {{ tab.name }}
          </button>
        </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4  mb-2 p-xl-4" v-for="event in events" :key="event.fe_id">
                <div class="card shadow h-100 cursor-pointer" style="width: 100%" @click="goToEvent(event.fe_id)">
                  <img
                    :src="IMAGEURL + event.fe_thumbnail"
                    class="card-img-top"
                    alt=""
                  />
                  <div class="card-body">
                    <h5 class="card_title">{{ event.fe_name }}</h5>
                    <p class="description flex-grow-1" v-html="event.fe_description"></p>
                    <div class="d-flex align-items-center">
                      <img src="@/assets/imgs/svgs/map-pin.svg" alt="" style="height:30px; width:30px"/>
                      <span class="ml-1 venue">
                        {{ event.fe_venue }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center mt-4">
                      <img src="@/assets/imgs/svgs/calendar_fea.svg" alt="" style="height:30px; width:30px" />
                      <span class="time ">
                        {{ new Intl.DateTimeFormat('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(event.fe_start_date)) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="events.length === 0" class="mt-5 ml-5">
              <h4 class="">No Events Available</h4>
              </div>
            </div>
          </div>
          </div>
          <div
            v-else-if="activeTabIndex === 1"
            class="tab-pane show active"
            id="v-pills-partner"
            role="tabpanel"
            aria-labelledby="v-pills-partner-tab"
          >
         
          <div class="nav nav-tabs" id="v-pills-tab" role="tablist">
          <button
            v-for="(tab, index) in periods"
            :key="index"
            class="nav-link"
            :id="`v-pills-${tab.id}-tab`"
            data-toggle="pill"
            :data-target="`#v-pills-${tab.id}`"
            type="button"
            role="tab"
            :aria-controls="`v-pills-${tab.id}`"
            :aria-selected="activeTabIndexForPeriod === index"
            :class="{ active: activeTabIndexForPeriod === index }"
            @click="onPeriodChange(tab.id)"
          >
            {{ tab.name }}
          </button>
        </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4  mb-2 p-xl-4" v-for="event in events" :key="event.fe_id">
                <div class="card shadow h-100 cursor-pointer" style="width: 100%" @click="goToEvent(event.fe_id)">
                  <img
                    :src="IMAGEURL + event.fe_thumbnail"
                    class="card-img-top"
                    alt=""
                  />
                  <div class="card-body">
                    <h5 class="card_title">{{ event.fe_name }}</h5>
                    <p class="description flex-grow-1" v-html="event.fe_description"></p>
                    <div class="d-flex align-items-center">
                      <img src="@/assets/imgs/svgs/map-pin.svg" alt="" style="height:30px; width:30px"/>
                      <span class="ml-1 venue">
                        {{ event.fe_venue }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center mt-4">
                      <img src="@/assets/imgs/svgs/calendar_fea.svg" alt="" style="height:30px; width:30px" />
                      <span class="time ">
                        {{ new Intl.DateTimeFormat('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(event.fe_start_date)) }}
                      </span>
                    </div>
                  </div>
                </div>
             
              </div>

              <div v-if="events.length === 0">
                <h4>No Events Available</h4>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import Ripple from "vue-ripple-directive";
import { IMAGEURL } from "@/config/index";

export default {
  components: {},
  directives: {
    Ripple,
  },
  data() {
    return {
      tabs: [
        { id: "corporate", name: "Corporate" },
        { id: "partner", name: "Partner" },
      ],
      periods: [
        { id: "upcoming", name: "Upcoming" },
        { id: "past", name: "Past" },
        { id: "all", name: "All" },
      ],
      activeTabIndex: 1,
      activeTabIndexForPeriod: 0,
      events: [],
      IMAGEURL,
      filters: {
        search: "",
        category: null,
        type: "franchise",
        franchise_id: null,
        period: "upcoming",
        
      },
      debounce: null,
    };
  },
  methods: {
    onPeriodChange(period) {
      this.activeTabIndexForPeriod = this.periods.findIndex((p) => p.id === period);
      this.filters.period = period;
      this.onFilterChange();
    },
   
    async getEvents() {
      try {
        const res = await homeServices.getEvents(this.filters);
        this.events = res.data.data.data;
      } catch (error) {
        console.error("Error in getEvents ", error);
      }
    },
    onFilterChange() {
      if (this.debounce) {
        this.debounce = null;
      }
      this.debounce = setTimeout(() => {
        this.getEvents(this.filters);
      }, 1000);
    },
    onChange(index) {
      this.activeTabIndex = index;
      if(index === 0){
        this.filters.type = "corporate";
      }else{
        this.filters.type = "franchise";
      }
      this.getEvents();

    },
    goToEvent(id) {
      this.$router.push({
        name: "EventDetail",
        query: { e_id: id },
      });
    }
  },
  beforeMount() {
    this.getEvents();
  },
};
</script>

<style scoped>
.form_elements {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.search-bar {
  width: 70%;
}
.button {
  width: 10%;
}
.category {
  width: 20%;
  margin-left: 10px;
}
.btn-btn {
  /* padding: 0 5px; */
}
.save_button_text {
  padding: 10px 10px;
}
.video-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  width: 100%;
}

.video-container {
  /* margin: 10px;  */
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  height: 320px;
}

.training-title {
  text-decoration: underline;
}

/* .video-container {
    height: auto;
    width: 70%;
    border-radius: 10px;
  } */

.dashboard__heading {
  color: #002884;
  font-weight: bold;
  margin-bottom: 1.2rem;
}

.student-dashboard .card-title {
  color: #000000;
  font-weight: 600;
}

.primary-color {
  color: #00d09c;
}

.min-height {
  min-height: 60vh;
}

.container {
  display: flex;
  height: 50vh;
  overflow: hidden;
}

.scrollable {
  height: 100%;
  overflow-y: auto;
}

.map-column {
  width: 60%;
}

iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.description{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: clamp(1.2rem, 2vw, 1.2rem) !important;
  color: #5c5c5c;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column-reverse;
    height: auto;
  }

  .scrollable {
    height: auto;
    overflow-y: visible;
  }

  .map-column {
    width: 100%;
  }
}

.card_title{
  font-size: clamp(1.5rem, 3vw, 1.5rem) !important;
}

.venue,.time{
  font-size: clamp(1.2rem, 2vw, 1.2rem) !important;

}
</style>


// WEBPACK FOOTER //
// src/components/pages/FranchiseEvents/Events.vue